<template>
  <div class="userLog-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input placeholder="请输入ID" size="small" v-model="params.uid" clearable @keyup.enter.native="getLoginLog('status')" class="param-input"></el-input>
      <el-date-picker v-model="time" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="small" @change="changeTime"></el-date-picker>
      <el-button type="primary" size="small" @click="getLoginLog('status')">搜索</el-button>
    </div>
    <!--表格数据-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" ref="multipleTable">
      <el-table-column prop="user.uid" label="ID" align="center" min-width="80">
        <template slot-scope="scope">
          <span>{{scope.row.user.uid || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="devID" label="UUID" align="center" min-width="320">
        <template slot-scope="scope">
          <span>{{scope.row.devID || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="devType" label="设备型号" show-overflow-tooltip align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{scope.row.devType || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sysType" label="设备类型" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{scope.row.sysType || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ver" label="版本号" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{scope.row.ver || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="user.createdAt" label="注册时间" align="center" min-width="240">
        <template slot-scope="scope">
          <span>{{scope.row.user.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="loginTime" label="登陆时间" align="center" min-width="240">
        <template slot-scope="scope">
          <span>{{scope.row.loginTime | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ip" label="ip" align="center" min-width="180">
        <template slot-scope="scope">
          <span>{{scope.row.ip || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" min-width="150">
        <template slot-scope="scope">
          <el-button v-if="!scope.row.user.hasLocked" type="danger" size="mini" @click="prohibit(scope.row)">封禁</el-button>
          <el-button v-else type="info" size="mini" @click="unprohibit(scope.row)">解封</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[ 10, 15, 20, 25]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
  </div>
</template>
<script>
import {changeTime} from '@/utils/global'
import API from '@/api'

export default {
  data() {
    return {
      tableData: [],
      time: '',
      loading: false,
      total: 0,
      // 请求订单列表参数
      params: {
        pageNumber: 1,
        pageSize: 20,
        startTime: '',
        endTime: '',
        uid: ''
      }
    }
  },
  created() {
    this.getLoginLog()
  },
  methods: {
    // 时间选择回掉
    changeTime(time) {
      if (time) {
        this.params.startTime = changeTime(time[0])
        this.params.endTime = changeTime(time[1])
      } else {
        this.params.startTime = ''
        this.params.endTime = ''
      }
      this.getLoginLog('status')
    },
    // 请求订单列表
    getLoginLog(type) {
      this.loading = true
      if (type === 'status') {
        this.params.pageNumber = 1
      }
      API.getLoginLog(this.params).then(res => {
        if (res.code === 200 && res.data.list) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size
      this.getLoginLog()
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number
      this.getLoginLog()
    },
    // 封禁用户
    prohibit(row) {
      this.$confirm('您确定要封禁当前用户吗？', '封禁提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            uidList: [row.user.uid],
            enable: true
          }
          this.lockUser(params)
        })
        // eslint-disable-next-line no-unused-vars
        .catch(_ => { });
    },
    // 解禁用户
    unprohibit(row) {
      this.$confirm('您确定要解封当前用户吗？', '解封提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            uidList: [row.user.uid],
            enable: false
          }
          this.lockUser(params)
        })
        .catch(() => { });
    },
    lockUser(params) {
      API.getUserLock(params).then(res => {
        if (res.code === 200) {
          if (params.enable) {
            this.$message({
              message: '封禁用户成功',
              type: 'success'
            })
          } else {
            this.$message({
              message: '解封用户成功',
              type: 'success'
            })
          }
          this.getLoginLog()
        } else {
          if (params.enable) {
            this.$message.error('封禁用户失败')
          } else {
            this.$message.error('解封用户失败')
          }
        }
      })
        .catch(() => { });
    },
  }
}
</script>
